(() => {
  const root = document.querySelector('[data-coffee-discovery]');
  const dialog = root?.querySelector('dialog');
  if (!dialog?.showModal) return;
  const question = root.querySelector('[data-coffee-question]');
  const result = root.querySelector('[data-coffee-result]');
  const put = (key, value) => { try { localStorage.setItem(key, value); } catch (_) {} };
  const track = (name, data = {}) => window.LoktEvents?.publish(`lokt_${name}`, data);
  let source = 'inline', choice = '', opener = null, scrollBefore = '';
  function photo(key) {
    const template = root.querySelector(`[data-coffee-template="${key}"]`);
    root.querySelector('[data-coffee-photo]').replaceChildren(template.content.cloneNode(true));
    return template.dataset;
  }
  function choose(key, focus = true) {
    const data = photo(key);
    choice = key;
    question.hidden = true;
    result.hidden = false;
    root.querySelector('[data-coffee-title]').textContent = data.title;
    root.querySelector('[data-coffee-description]').textContent = data.body;
    root.querySelector('[data-coffee-pack]').textContent = data.pack;
    root.querySelector('[data-coffee-product]').href = data.url;
    root.querySelector('[data-coffee-product]').dataset.flavor = key;
    root.querySelectorAll('[data-tasting-tags]').forEach(el => { el.value = `newsletter,lokt_tasting_list,coffee_${key}`; });
    dialog.setAttribute('aria-labelledby', 'lk-discovery-result');
    try { sessionStorage.setItem('lokt_coffee_choice', key); } catch (_) {}
    dialog.scrollTop = 0;
    if (focus) root.querySelector('[data-coffee-title]').focus();
  }
  function open(trigger, origin) {
    if (dialog.open) return;
    opener = trigger;
    source = origin;
    photo(choice || 'espresso');
    scrollBefore = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    (question.hidden ? root.querySelector('[data-coffee-title]') : root.querySelector('#lk-discovery-title')).focus();
    track('coffee_finder_open', { source });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-coffee-finder]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    open(link, link.dataset.coffeeFinder);
  });
  root.querySelectorAll('[data-coffee-choice]').forEach(button => button.addEventListener('click', () => {
    choose(button.dataset.coffeeChoice);
    track('coffee_flavor_chosen', { flavor: choice, source });
  }));
  root.querySelector('[data-coffee-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = scrollBefore;
    if (opener?.isConnected && !opener.closest('[hidden]')) opener.focus({ preventScroll: true });
    track('coffee_finder_close', { source, flavor: choice });
  });
  root.querySelector('[data-coffee-back]').addEventListener('click', () => {
    result.hidden = true;
    question.hidden = false;
    dialog.setAttribute('aria-labelledby', 'lk-discovery-title');
    dialog.scrollTop = 0;
    root.querySelector('[data-coffee-choice]').focus();
  });
  root.querySelector('[data-coffee-product]').addEventListener('click', () => track('coffee_recommendation_click', { flavor: choice, source }));
  document.querySelectorAll('.lk-tasting-form').forEach(form => form.addEventListener('submit', () => {
    track('tasting_signup_submit', { form: form.id, flavor: form.id === 'LOKTTastingFinder' ? choice : '' });
  }));
  const returningForm = location.hash.slice(1);
  if (returningForm.startsWith('LOKTTasting')) {
    const returned = document.getElementById(returningForm);
    if (returned?.querySelector('[data-tasting-success]')) put('lokt_tasting_subscribed', '1');
    if (returningForm === 'LOKTTastingFinder' && returned?.querySelector('[data-tasting-success], [data-tasting-error]')) {
      let previous = 'espresso';
      try { previous = sessionStorage.getItem('lokt_coffee_choice') || previous; } catch (_) {}
      choose(['espresso', 'vanilla', 'both'].includes(previous) ? previous : 'espresso', false);
      open(null, 'signup_return');
      returned.querySelector('[data-tasting-success], input[type="email"]')?.focus();
    }
  }
  /* No auto-appearing invitation (owner rule, 2026-09-27: no unwanted popups). The finder opens only
     from a shopper's click on a [data-coffee-finder] link, or on return from its own signup form. */
})();
